<template>
  <div class="distributor-box">
    <!--tab栏区域-->
    <Tabs v-model="pageParams.orderTabStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in orderTabTypeList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <template v-if="pageParams.orderTabStatus === '6'">
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1006167')" prop="orderShippingIds">
                <Input type="textarea" :placeholder="$t('key1006168')" v-model.trim="pageParams.orderShippingIds"></Input>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1006169')" prop="sourceRemark">
                <Input v-model.trim="pageParams.sourceRemark" clearable/>
              </Form-item>
            </Col>
          </template>
          <template v-else>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="`${configCharacters()}` + $t('key1004602')" prop="ymsStatus">
                <Select v-model="pageParams.ymsStatus">
                  <Option v-for="item in ymsOrderStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1004513')" class="date_picker_style">
                <Date-picker
                  type="datetimerange"
                  @on-clear="resetDate"
                  @on-change="getDateValue"
                  :clearable="true"
                  :options="dateOptions"
                  format="yyyy-MM-dd HH:mm:ss"
                  placement="bottom-end"
                  :placeholder="$t('key1000360')"
                  :value="registerTime">
                </Date-picker>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
              <Form-item :label="$t('key1004387')" prop="labelType">
                <Select v-model="pageParams.labelType">
                  <Option v-for="item in labelTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.orderTabStatus === '0'">
              <Form-item :label="$t('key1004363')" prop="abnormalStatus">
                <Select v-model="pageParams.abnormalStatus">
                  <Option v-for="item in abnormalStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <dropDownFilter
                :transfer="false"
                ref="dropDownFilter"
                inputType="textarea"
                :selectStyle="{width: '100px'}"
                :dropDownInputList="dropDownInputList"
                :defaultSelectValue="defaultSelectValue"
                @changeInput="changeInput"
                @updateInputValue="updateInputValue">
              </dropDownFilter>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1006170')" prop="payStatus">
                <Select v-model="pageParams.payStatus">
                  <Option v-for="(item, index) in payStatusList" :value="item.value" :key="index">{{ item.title }}</Option>
                </Select>
              </Form-item>
            </Col>
          </template>
          <Col style="min-width: 180px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <!--添加订单-->
      <Button class="mr15" type="primary" @click="$router.push('/addCloudSalesOrder')">{{ $t('key1006171') }}</Button>
      <!--导出订单-->
      <Dropdown transfer @on-click="changeExportBtn" class="mr15">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--批量导入订单-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsDistributorPackageInfo_excelImport')"
        @click="$refs['batchImportOrders'].initBatchImportOrdersData()">{{ $t('key1006172') }}</Button>
      <!--批量付款-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsDistributorPackageInfo_payToCreateOrder') &&
        pageParams.orderTabStatus === '6'" @click="bulkOrderingBtn">{{ $t('key1006173') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        @on-selection-change="tableChange"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--跟踪信息弹窗-->
    <trackingInfoModal ref="trackingInfo"></trackingInfoModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1000792')+`${configCharacters()}`+$t('key1001887')"
      paramKeyColums="ymsDistributorPackageInfoExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--订单轨迹弹窗-->
    <orderTrajectoryModal
      ref="orderTrajectory"
      :shippingMethodList="shippingMethodList"
      form="myOrder">
    </orderTrajectoryModal>
    <!--取消订单弹窗-->
    <cancelYmsOrderModal ref="cancelYmsOrder" @cancelYmsOrderSuccess="cancelYmsOrderSuccess"></cancelYmsOrderModal>
    <!--批量导入订单弹窗-->
    <batchImportOrdersModal ref="batchImportOrders" @updateData="pageParamsStatus = true"></batchImportOrdersModal>
    <!--付款弹窗-->
    <distributorPaymentModal
      orderSource="myOrder"
      ref="distributorPayment"
      @updateData="pageParamsStatus = true">
    </distributorPaymentModal>
    <!--查看定制内容弹窗-->
    <viewCustomizedInfoModal ref="viewCustomizedInfo"></viewCustomizedInfoModal>
    <!--取消定制商品订单弹窗-->
    <cancelCustomizedProductOrdersModal
      ref="cancelCustomizedProductOrders"
      @cancelYmsOrderSuccess="cancelYmsOrderSuccess"
    ></cancelCustomizedProductOrdersModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal ref="orderSubmission" @updateOrderData="updateOrderData"></orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import trackingInfoModal from "@/components/common/trackingInfoModal";
import api from '@/api/';
import {YMSORDERSTATUSLIST} from "@/utils/enum";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import dropDownFilter from "@/components/common/dropDownFilter";
import orderTrajectoryModal from "@/views/distributor/components/orderManage/components/orderTrajectoryModal";
import {
  _handleMultilingualFields, getDataSetBatchList, getEnumList, getQueryCarrierShippingName, getSupplierLogisticsData, getYunLogisticsAll,
  jumpToTheCourierInquiry, pageJump, setConfigCharacters, sumAmount, getEnumName, getTrackingNumberDisplayType
} from "@/utils/common";
import cancelYmsOrderModal from "@/views/distributor/components/orderManage/components/cancelYmsOrderModal.vue";
import batchImportOrdersModal from "@/views/distributor/components/orderManage/batchImportOrdersModal.vue";
import distributorPaymentModal from "@/components/common/distributorPaymentModal.vue";
import viewCustomizedInfoModal from "@/components/common/viewCustomizedInfoModal.vue";
import cancelCustomizedProductOrdersModal from "@/components/common/cancelCustomizedProductOrdersModal.vue";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";

export default {
  name: "myOrder",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      registerTime: [],
      pageParamsStatus: false,
      pageParams: {
        orderTabStatus: 'null',
        payStatus: 'null',
        createdStartTime: null,
        createdEndTime: null,
        sourceRemark: '',
        packageCodes: '',
        orderShippingIds: '',
        trackingNumbers: '',
        labelType: 'null',
        ymsStatus: 'null',
        abnormalStatus: 'null',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'left'
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004432')}`,
          key: 'ymsOrderInfo',
          align: 'left',
          fixed: 'left',
          minWidth: 280,
          render(h, params) {
            // 订单编号
            let orderNo = [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004534')),
              h('Alink', {
                props: {
                  linkName: params.row.packageCode,
                  AlinkShow: v.getPermission('get_ymsDistributorPackageInfo')
                },
                on: {
                  AlinkBtn: () => {
                    v.$router.push({
                      path: '/myOrderDetails',
                      query: {
                        ymsPackageId: params.row.ymsPackageId
                      }
                    });
                  }
                }
              })
            ];
            // 第三方单号
            let orderShippingId = params.row.orderShippingId;
            // 下单时间
            let createdTime = params.row.createdTime;
            createdTime = v.$uDate.dealTime(createdTime, 'fulltime');
            // 面单类型
            let labelTypeText = '-';
            let labelType = params.row.labelType;
            v.labelTypeList.map((item) => {
              if (item.value === labelType) {
                if (labelType === 'null') {
                  labelTypeText = '-';
                } else {
                  labelTypeText = item.title;
                }
              }
            });
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1 flex flex-align-center'}, [orderNo]),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006144') + orderShippingId),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004337') + createdTime),
              h('p', {class: 'mt2 mb2'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004387') + labelTypeText)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'shippingInfo',
          align: 'left',
          minWidth: 330,
          render(h, params) {
            let performanceType = params.row.performanceType;
            let logisticsCarrier = params.row.logisticsCarrier;
            let carrierName = _handleMultilingualFields(params.row.carrierName) || '-';
            let carrierShippingMethodName = _handleMultilingualFields(params.row.carrierShippingMethodName) || '';
            // 物流方式
            let shippingMethodName = carrierName + (carrierShippingMethodName ? ' > ' + carrierShippingMethodName : '') +
              (logisticsCarrier ? '（' + logisticsCarrier + '）' : '');
            // 运单号
            let trackingNumber = params.row.trackingNumber || '-';
            let trackCarrierCode = params.row.trackCarrierCode;
            let displayType = getTrackingNumberDisplayType(params.row);
            let trackingNodes = [h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001521'))];
            if (displayType === 'waiting') {
              trackingNodes.push(h('span', {class: 'distributorThemeColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004537')));
            } else if (displayType === 'failed') {
              trackingNodes.push(h('span', {style: {color: 'redColor'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006145')));
            } else {
              trackingNodes.push(h('span', trackingNumber));
            }
            if (displayType === 'normal' && trackCarrierCode) {
              trackingNodes.push(h('Icon', {
                props: {type: 'ios-flag', size: 24},
                class: 'cursor ml5 distributorThemeColor',
                on: {
                  click: () => {
                    v.$refs['trackingInfo'].getPackageLogisticsTracking(params.row.ymsPackageId);
                  }
                }
              }));
            }
            // 国内快递单号
            let selfDeliveryTrackingText = '';
            let selfDeliveryTrackingNumber = params.row.selfDeliveryTrackingNumber || '-';
            if (selfDeliveryTrackingNumber) {
              selfDeliveryTrackingText = [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004530') + selfDeliveryTrackingNumber),
                selfDeliveryTrackingNumber !== '-' ? h('Tooltip', {
                  props: {
                    maxWidth: 400,
                    transfer: true,
                    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006146'),
                    placement: 'top'
                  }
                }, [
                  h('Icon', {
                    props: {type: 'md-help-circle', size: 17},
                    class: 'cursor ml5'
                  })
                ]) : ''
              ];
            }

            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1'}, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004643')),
                performanceType === 2 ? h('span', {class: 'TiktokCBT_box'}, 'Tiktok-CBT') : '',
                h('span', shippingMethodName)
              ]),
              h('p', {class: 'mt2 mb2 flex align-items-center'}, trackingNodes),
              h('p', {class: 'mt2 mb2'}, selfDeliveryTrackingText)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006147'),
          align: 'left',
          key: 'sourceRemark',
          width: 200,
          render: (h, params) => {
            return v.checkContentOverflow(h, params.row.sourceRemark, 200, 2)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006148'),
          key: 'destinationBuyerInfo',
          align: 'left',
          minWidth: 230,
          render(h, params) {
            // 目的地
            let buyerCountryCode = params.row.buyerCountryCode || '-';
            // 买家ID
            let destination = params.row.buyerAccountId || '-';
            // 买家姓名
            let buyerName = params.row.buyerName || '-';
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006149') + buyerCountryCode),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006150') + destination),
              h('p', {class: 'mt2 mb2'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006110') + buyerName)
            ]);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006142')}`,
          key: 'ymsOrderItemInfo',
          align: 'left',
          minWidth: 280,
          render(h, params) {
            let list = [];
            let ymsPackageGoods = params.row.ymsPackageGoods || [];
            if (ymsPackageGoods.length > 0) {
              let num = ymsPackageGoods.length - 3;
              ymsPackageGoods.map((item, index) => {
                let skuImg = '';
                let spuImg = '';
                if (item._productInfo) {
                  skuImg = item._productInfo.primaryImage;
                  spuImg = item._productInfo._spuInfo.primaryImage
                }
                let primaryImage = skuImg || spuImg || v.failPlaceholder;
                if (index <= 2) {
                  list.push(h('div',
                    {
                      class: 'ymsPackageGoodBox',
                      on: {
                        click() {
                          v.$router.push({
                            path: '/myOrderDetails',
                            query: {
                              ymsPackageId: params.row.ymsPackageId
                            }
                          });
                        },
                        error($event) {
                          v.setErrorImg($event)
                        }
                      }
                    },
                    [
                      h('img', {
                        attrs: {src: v.getThumbnailImage(primaryImage, '/thumb/', '70x70', true) || v.failPlaceholder},
                        class: 'ymsPackageGoodImg'
                      }),
                      h('span', {class: 'ymsPackageGoodQuantity'}, 'x' + item.quantity),
                      num > 0 && index === 2 ? h('div', {class: 'maskBox font-size-18 font-weight-bold color-white'}, '+' + num) : ''
                    ]));
                }
              });
            }
            return h('div', {class: 'flex flex-align-center'}, list);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')}`,
          key: 'ymsOrderStatus',
          align: 'left',
          minWidth: 230,
          render(h, params) {
            let title = '';
            let time = '';
            let expressageNo = '';
            let expressageCode = '';
            let trackingNumber = '';
            let transportTypeTalg = params.row.transportType === 2; // 上门揽收
            let ymsStatus = params.row.ymsStatus;
            let ymsPackageId = params.row.ymsPackageId;
            let payStatus = params.row.payStatus;
            let offlinePaymentStatus = params.row.offlinePaymentStatus;
            let status = params.row.status; // 订单状态
            let timeFormat = v.countdowns[ymsPackageId]?.leftTime || '';
            YMSORDERSTATUSLIST.map((item) => {
              if (item.value === ymsStatus) {
                title = item.name;
                time = v.$uDate.dealTime(params.row[item.key], 'fulltime');
                // 已装箱
                if (item.key === 'supperBoxedTime') {
                  expressageNo = params.row.expressageNo;
                  expressageCode = params.row.expressageCode;
                  trackingNumber = params.row.trackingNumber;
                }
              }
            })
            return h('div', [
              h('p',
                {
                  class: 'mt4 mb1 distributorThemeColor cursor',
                  on: {
                    click() {
                      v.$refs['orderTrajectory']['initOrderTrajectoryData'](params.row);
                    }
                  }
                },
                title),
              timeFormat && status !== 8 && payStatus === 1 && ![2].includes(offlinePaymentStatus) ?
                h('p', {class: 'mt4 mb1 distributorThemeColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006151') + timeFormat) : '',
              expressageNo && !transportTypeTalg ? h('p', {class: 'flex align-items-center'}, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004362')),
                h('span', {
                  class: 'distributorThemeColor cursor',
                  on: {
                    click() {
                      jumpToTheCourierInquiry(expressageCode, expressageNo, trackingNumber)
                    }
                  }
                }, expressageNo),
              ]) : '',
              h('p', {class: 'mt2 mb2'}, time)
            ]);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')}`,
          key: 'ymsOrderAmount',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let payStatus = params.row.payStatus; // 1:待付款 2:确认中 3:被退回 4:已完成 5:已取消 6:付款中
            let totalSuggestPrice = params.row.totalSuggestPrice;
            let estimateFreight = params.row.estimateFreight;
            let handlerCost = params.row.packageHandlerCost;
            let totalPriceCurrency = params.row.totalPriceCurrency;
            let ymsPackageCosts = params.row.ymsPackageCosts || [];
            let ymsLogisServiceId = params.row.ymsLogisServiceId;
            let originalObj = sumAmount(ymsPackageCosts);
            let prepayPackageHandlerCost = params.row.prepayPackageHandlerCost;
            let list = [
              v.expenseProcessingFun(h, params, 11, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004526')),
              v.expenseProcessingFun(h, params, 12, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004527')),
              v.expenseProcessingFun(h, params, 13, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004528')),
              v.expenseProcessingFun(h, params, 14, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004529')),
            ];
            // 总费用
            let totalPrice = params.row.totalPrice ? params.row.totalPrice + ' ' + v.currencyState : 0;
            // 商品费
            let packageHandlerCost = v.expenseProcessingFun(h, params, 1, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006152'));
            // 实扣处理费
            let processingFee = v.expenseProcessingFun(h, params, 2, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006153'));
            // 预扣处理费
            let preDeductedProcessingFee = v.expenseProcessingFun(h, params, 15, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006154'));
            // 物流费
            let estimateFreightCost = (v.expenseProcessingFun(h, params, 4, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006155')) || v.expenseProcessingFun(h, params, 9, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006155')));
            // 国内快递费
            let domesticExpressChargeText = '';
            let domesticExpressFreightTalg = ymsPackageCosts.some((item) => {
              return item.type === 6;
            });
            // 预扣物流费
            let prepaidLogisticsFees = '-';
            if (ymsPackageCosts.length > 0) {
              prepaidLogisticsFees = sumAmount(ymsPackageCosts, 4, {withCurrency: true, decimals: 2, thousand: true}) ||
                sumAmount(ymsPackageCosts, 9, {withCurrency: true, decimals: 2, thousand: true});
            } else {
              prepaidLogisticsFees = v.formatCurrency(estimateFreight) + ' ' + totalPriceCurrency;
            }

            if (domesticExpressFreightTalg) {
              domesticExpressChargeText = [
                v.expenseProcessingFun(h, params, 6, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004519')),
                h('Tooltip', {
                  props: {
                    maxWidth: 400,
                    transfer: true,
                    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006146'),
                    placement: 'top'
                  }
                }, [
                  h('Icon', {
                    props: {type: 'md-help-circle', size: 17},
                    class: 'cursor ml5'
                  })
                ])
              ];
            }
            // 清关费用
            let customsClearanceFee = '';
            let customsClearanceFeeTalg = ymsPackageCosts.some((item) => {
              return item.type === 7;
            });
            if (customsClearanceFeeTalg) {
              customsClearanceFee = v.expenseProcessingFun(h, params, 7, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006156'));
            }
            if (ymsLogisServiceId) {
              let talg = sumAmount(ymsPackageCosts, 10) === '-';
              let actualDeductionOfLogisticsFees = sumAmount(ymsPackageCosts, 10, {withCurrency: true, decimals: 2, thousand: true})
              list.push(
                originalObj[10] ? h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006155') + actualDeductionOfLogisticsFees) : '',
                talg ? h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006157') + prepaidLogisticsFees) : ''
              )
            } else {
              if (payStatus === 4) {
                list.push(estimateFreightCost)
              } else {
                if (estimateFreight) {
                  list.push(h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006155') + v.formatCurrency(estimateFreight) + ' ' + totalPriceCurrency))
                }
              }
            }

            return h('div', {class: 'flex flex-direction'},
              payStatus === 4 ? [
                h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003690') + totalPrice),
                h('p', {class: 'mt2 mb1'}, [packageHandlerCost]),
                originalObj[15] ? h('p', {class: 'mt2 mb1'}, [preDeductedProcessingFee]) : '',
                originalObj[2] ? h('p', {class: 'mt2 mb1'}, [processingFee]) : '',
                ...list,
                h('p', {class: 'mt2 mb1 flex align-items-center'}, domesticExpressChargeText),
                h('p', {class: 'mt2 mb2'}, [customsClearanceFee])
              ] : [
                h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003690') + totalPrice),
                totalSuggestPrice ? h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006152') + v.formatCurrency(totalSuggestPrice) + ' ' + totalPriceCurrency) : '',
                prepayPackageHandlerCost ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006154') + v.formatCurrency(prepayPackageHandlerCost) + ' ' + totalPriceCurrency) : '',
                handlerCost ? h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006153') + v.formatCurrency(handlerCost) + ' ' + totalPriceCurrency) :
                  originalObj[2] ? h('p', {class: 'mt2 mb1'}, [processingFee]) : '',
                ...list,
              ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081'),
          key: 'payStatus',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let text = '';
            let content = params.row.returnReason;
            v.payStatusList.map((item) => {
              if (item.value === payStatus) {
                text = item.title;
              }
            });
            return h('div', {class: 'flex align-items-center'}, [
              h('p', text),
              payStatus === 3 ? h('Tooltip', {
                props: {
                  transfer: true,
                  content: content,
                  maxWidth: 300,
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  class: 'ml2 cursor',
                  props: {
                    type: 'ios-alert-outline',
                    size: 17,
                    color: '#FD5425'
                  }
                })
              ]) : ''
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          align: 'left',
          minWidth: 200,
          render: (h, params) => {
            let text = '';
            let packageGoodsStatus = params.row.packageGoodsStatus; // 订单货品状态 1、补货中 2、部分补货中 3 部分缺货 商品已停售,4、缺货,商品已停售
            let ymsPackageGoods = params.row.ymsPackageGoods || [];
            let totalOutOfStockQuantity = ymsPackageGoods.reduce((accumulator, currentItem) => accumulator + currentItem.outOfStockQuantity, 0);
            let txt = getEnumName(v.enumData, 'YmsPackageInfoPackageGoodsStatusCoreEnum', packageGoodsStatus, 'number');
            let abnormalStatus = params.row.abnormalStatus;
            let carrierErrorMsg = params.row.carrierErrorMsg || ''; // 下发物流失败原因
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ? v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let expectedDeliveryTimeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006118') + estimateArrivalOfGoodsTime + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006119');
            v.abnormalStatusList.map((item) => {
              if (item.value === abnormalStatus) {
                text = item.title;
              }
            });
            let list = [];
            if (packageGoodsStatus === 4) {
              list = [h('div', {class: 'crimsonRedColor'}, txt)];
            } else {
              switch (abnormalStatus) {
                // 无异常
                case 1:
                  list = [h('span', '-')];
                  break;
                // 缺货
                case 2:
                  list = [
                    h('div', {class: 'crimsonRedColor'}, [
                      h('p', text),
                      txt ? h('div', [
                        h('p', {class: 'crimsonRedColor'}, txt),
                        estimateArrivalOfGoodsTime ? h('div', {class: 'flex'}, [
                          h('span', {class: 'crimsonRedColor'}, expectedDeliveryTimeText),
                          h('Tooltip', {
                            props: {
                              transfer: true,
                              maxWidth: 400,
                              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006120')
                            },
                            style: {
                              marginLeft: '5px'
                            }
                          }, [
                            h('Icon', {
                              props: {
                                type: 'md-information-circle',
                                size: 16
                              },
                              style: {
                                cursor: 'pointer',
                                color: 'red'
                              }
                            })
                          ]),
                        ]) : '',
                        totalOutOfStockQuantity > 0 ? h('p', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360')}${totalOutOfStockQuantity}`) : ''
                      ]) : ''
                    ])
                  ]
                  break;
                // 下发物流失败
                case 3:
                  list = [
                    h('div', [
                      h('span', text),
                      h('Tooltip', {
                        props: {
                          transfer: true,
                          maxWidth: 400,
                          content: carrierErrorMsg
                        },
                        style: {
                          marginLeft: '5px'
                        }
                      }, [
                        h('Icon', {
                          props: {
                            type: 'md-information-circle',
                            size: 16
                          },
                          style: {
                            cursor: 'pointer',
                            color: 'red'
                          }
                        })
                      ])
                    ])
                  ];
                  break;
              }
            }
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          fixed: 'right',
          width: 110,
          render(h, params) {
            let abnormalStatus = params.row.abnormalStatus;
            let handTalg = params.row.isHand === 2; // 是否手工单:(0:否 1:平台手工单 2:yms手工单)
            let sourceTalg = params.row.source !== 'YMS'; // 第三方渠道的订单
            let status = params.row.status; // 订单状态
            let allowInvalid = params.row.allowInvalid; // 1 允许标记取消   0不允许标记取消
            let payStatus = params.row.payStatus; // 付款状态 1:待付款 2:确认中 3被退回 4已完成 5已取消
            let isNeedCustomization = params.row.isNeedCustomization;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004290'),
                    show: (isNeedCustomization === 0 && (![6, 7, 8].includes(status) || (abnormalStatus === 2 && status !== 8)
                        || (allowInvalid === 1 && status === 6)) || (isNeedCustomization === 1 && status !== 8))
                      && v.getPermission('ymsPlatformOrder_cancelOrder') && (handTalg || sourceTalg),
                    clickFn: () => {
                      // 取消定制商品订单
                      if (isNeedCustomization === 1) {
                        if (allowInvalid === 1) {
                          v.$refs['cancelCustomizedProductOrders'].initCancelCustomizedProductOrdersData('distributorCancelOrder', params.row)
                        } else {
                          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006134'));
                          return false;
                        }
                      }
                      // 取消普通订单
                      else {
                        v.$Modal.confirm({
                          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006158'),
                          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006159'),
                          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
                          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                          onOk: () => {
                            v.cancelOrderBtn(params.row);
                          },
                          onCancel: () => {

                          }
                        });
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000609'),
                    show: [1, 3].includes(payStatus) && v.getPermission('ymsDistributorPackageInfo_payToCreateOrder'),
                    clickFn: () => {
                      let obj = {
                        totalPrice: Number(params.row.totalPrice),
                        currency: params.row.totalPriceCurrency,
                        params: {
                          url: api.post_ymsDistributorPackageInfo_payToCreateOrder,
                          query: {
                            packageCodes: [params.row.packageCode]
                          }
                        }
                      }
                      v.$refs['orderSubmission'].initOrderSubmissionData(obj, true)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004533'),
                    show: abnormalStatus === 3,
                    clickFn: () => {
                      v.distributionLogisticsBtn(params.row.ymsPackageId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001525'),
                    show: isNeedCustomization === 1 && status !== 8,
                    clickFn: () => {
                      v.$refs['viewCustomizedInfo'].initViewCustomizedInfoData(params.row);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      abnormalStatusList: [ // 1.正常 2.缺货 3.下发物流失败
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006160')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')},
        {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006161')},
      ],
      shippingMethodList: [],
      selectTableData: [],
      exportType: null,
      dropDownInputList: [
        {title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, value: 1, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006143')}`, parameterKey: 'packageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003629'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006162'), parameterKey: 'orderShippingIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006163'), parameterKey: 'trackingNumbers'},
      ],
      defaultSelectValue: 1,
      customFieldExportList: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004432')}`,
          titleKey: 'orderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2, 3], paramKey: 'packageCode', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, disabled: true, disabledDrag: true},
            {type: [1, 2, 3], paramKey: 'ymsStatus', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')}`},
            {type: [1, 2, 3], paramKey: 'ymsSku', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004433')}`},
            {type: [1, 2, 3], paramKey: 'SKU', paramValue: 'SKU'},
            {type: [1, 2, 3], paramKey: 'productQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {type: [1, 2, 3], paramKey: 'amount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004452')},
            {type: [1, 2, 3], paramKey: 'totalAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004453')},
            {type: [1, 2, 3], paramKey: 'handlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006164')},
            {type: [1, 2, 3], paramKey: 'prepayHandlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006165')},
            {type: [1, 2, 3], paramKey: 'totalShippingFeeIncome', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004456')},
            {type: [1, 2, 3], paramKey: 'actualLogisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004457')},
            {type: [1, 2, 3], paramKey: 'returnedItemShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003637')},
            {type: [1, 2, 3], paramKey: 'remoteAreasShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003638')},
            {type: [1, 2, 3], paramKey: 'quadraticShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003639')},
            {type: [1, 2, 3], paramKey: 'cancelShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003640')},
            {type: [1, 2, 3], paramKey: 'ymsLogisServiceName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005379')},
            {type: [1, 2, 3], paramKey: 'thirdPartyNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440')},
            {type: [1, 2, 3], paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004458')},
            {type: [1, 2, 3], paramKey: 'virtualTrackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004459')},
            {type: [1, 2, 3], paramKey: 'packageCreatedTime', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003663')}`},
            {type: [1, 2, 3], paramKey: 'shipedTime', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003661')}`},
            {type: [1, 2, 3], paramKey: 'ymsLogisServiceEfficiency', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001613')}`},
            {type: [1], paramKey: 'ymsOrderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
            {type: [1, 2, 3], paramKey: 'orderShippingId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003629')},
            {type: [1, 2, 3], paramKey: 'exceptionStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')},
            {type: [1, 2, 3], paramKey: 'payStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081')},
            {type: [1, 2, 3], paramKey: 'buyerName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006122')},
            {type: [1, 2, 3], paramKey: 'buyerName2', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004467'),
          titleKey: 'platformOrderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2, 3], paramKey: 'platformName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793')},
            {type: [1, 2, 3], paramKey: 'siteName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004468')},
            {type: [1, 2, 3], paramKey: 'platformAccountName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004469')},
            {type: [1, 2, 3], paramKey: 'platformOrderId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004470')},
            {type: [1, 2, 3], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004471')},
            {type: [1, 2, 3], paramKey: 'totalPriceCurrency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003611')},
            {type: [1, 2, 3], paramKey: 'platformOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004472')},
            {type: [1, 2, 3], paramKey: 'platformItemSku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004473')},
            {type: [1, 2, 3], paramKey: 'createdYmsPackageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474')},
            {type: [1, 2, 3], paramKey: 'payTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004475')},
            {type: [1], paramKey: 'orderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')}
          ]
        }
      ],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004476')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004477'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004478')},
        {value: 3, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004477'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004479'), iconCenter: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004480')}
      ],
      reviewedTotal: 0,
      orderTabTypeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: '6', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800')},
        {
          value: '0',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006166')),
              h('Badge', {
                props: {
                  count: v.reviewedTotal,
                  overflowCount: 999
                }
              })
            ])
          }
        },
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799')},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006130')},
        {value: '3', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}`},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '5', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      ymsOrderStatusList: YMSORDERSTATUSLIST.filter((item) => {
        return item.value !== 11
      }),
      countdownsTime: {},
      countdowns: {},
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    // 付款状态
    payStatusList() {
      const ENUM_KEY = 'YmsPackageInfoOfflinePayStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 面单类型
    labelTypeList() {
      const ENUM_KEY = 'YmsPickupOrderLabelTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = [
        'YmsPackageInfoOfflinePayStatusCoreEnum',
        'YmsPackageInfoPackageGoodsStatusCoreEnum',
        'YmsPickupOrderLabelTypeCoreEnum'
      ];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.handleColumns();
      this.getProductsNum();
      this.reset();
      this.search();
    },
    // 查询按钮
    search() {
      this.$nextTick(() => {
        this.$refs['selection'].selectAll(false);
      })
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      let keyList = ['abnormalStatus', 'orderTabStatus', 'status', 'ymsStatus', 'labelType', 'payStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : key === 'labelType' ? v.pageParams[key] : Number(v.pageParams[key]);
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.total = 0;
      let ymsProductGoodsIdList = [];
      let ymsProductGoodsIds = [];
      v.shippingMethodList = [];
      v.axios.post(api.post_ymsDistributorPackageInfo_query, v.handleParameter()).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.total = data.total;
            let newList = data.list || [];
            if (newList.length > 0) {
              /*供应商备货状态：
               待拣货：printTime
               待复核：pickingFinishTime
               待装箱：packingTime
               已装箱：supperBoxedTime
               已出库：despatchTime

               YMS处理状态：
               分拣中：allottedTime packagePattern = 2
               待拣货：allottedTime packagePattern = 1
               已拣货：pickedTime
               已换单：changedLabelTime
               已装箱：boxedTime
               已发货：shipedTime*/
              newList.map((item) => {
                let ymsStatus = item.ymsStatus;
                item.trajectoryStatusList = [];
                let ymsPackageGoods = item.ymsPackageGoods || [];
                if (ymsPackageGoods.length > 0) {
                  ymsProductGoodsIdList.push(...ymsPackageGoods);
                  ymsPackageGoods.map((ele) => {
                    ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                  })
                }
                // 处理轨迹状态数据
                let sort;
                YMSORDERSTATUSLIST.map((k) => {
                  if (k.value === ymsStatus && k.value !== 'null') {
                    sort = k.sort;
                  }
                });
                let keyList = YMSORDERSTATUSLIST.filter((k) => {
                  return k.sort <= sort;
                });
                if (keyList.length > 0) {
                  keyList.map((ele) => {
                    for (let key in item) {
                      if (ele.key === key) {
                        if (item[key]) {
                          if (key === 'allottedTime') {
                            if (item.packagePattern === 1) {
                              item.allottedTime = item.allottedTime;
                            } else if (item.packagePattern === 2) {
                              item.allottedTime = item.allottedTime;
                            }
                          }
                          item.trajectoryStatusList.push(ele);
                        }
                      }
                    }
                  })
                }
              });
              const shippingMethodIds = Array.from(new Set(newList.map(item => item.shippingMethodId).filter(Boolean)));
              Promise.all([
                getYunLogisticsAll(),
                getSupplierLogisticsData(shippingMethodIds),
                getQueryCarrierShippingName(shippingMethodIds)
              ]).then(([ymsLogistics, supplierLogistics, distributorLogistics]) => {
                v.shippingMethodList = distributorLogistics || [];
                if (ymsProductGoodsIds.length > 0) {
                  (async () => {
                    let newData = await v.getProductInfoByIds(ymsProductGoodsIds, ymsProductGoodsIdList);
                    newList.map((item) => {
                      item.logisticsCarrier = null;
                      // 分销商物流
                      if (distributorLogistics.length > 0 && item.shippingMethodId) {
                        const carrierInfo = distributorLogistics.find(e => e.shippingMethodId === item.shippingMethodId);
                        if (carrierInfo) {
                          item.carrierShippingMethodName = carrierInfo.carrierShippingMethodName;
                          item.carrierName = carrierInfo.carrierName;
                          item.logisticsCarrier = carrierInfo.logisticsCarrier;
                          item.performanceType = carrierInfo.performanceType;
                        }
                      }
                      // 供应商物流
                      if (supplierLogistics.length > 0 && item.shippingMethodId) {
                        const carrierInfo = supplierLogistics.find(e => e.shippingMethodId === item.shippingMethodId);
                        if (carrierInfo) {
                          item.carrierShippingMethodName = carrierInfo.carrierShippingMethodName;
                          item.carrierName = carrierInfo.carrierName;
                          item.logisticsCarrier = carrierInfo.logisticsCarrier;
                          item.performanceType = carrierInfo.performanceType;
                        }
                      }
                      // 云卖物流
                      if (ymsLogistics.length > 0 && item.ymsLogisServiceId) {
                        const ymsService = ymsLogistics.find(e => e.ymsLogisServiceId === item.ymsLogisServiceId);
                        if (ymsService) {
                          item.carrierName = ymsService.name;
                        }
                      }

                      item.ymsPackageGoods = newData.filter((ele) => {
                        return ele.ymsPackageId === item.ymsPackageId;
                      });
                      v.countdownsTime[item.ymsPackageId] = {
                        payLeftTime: item.payLeftTime || null
                      }
                      // 启动倒计时
                      if (item.payLeftTime) {
                        v.handleCountDown(item.ymsPackageId);
                      }
                    });
                    v.tableData = newList;
                    v.updateTableDom('selection');
                  })();
                } else {
                  v.tableData = newList;
                  v.updateTableDom('selection');
                }
              }).finally(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          }
        }
      }).catch(() => {
        v.tableLoading = false;
      });
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.registerTime = [];
      v.resetDate();
      v.changeInput(1);
      v.setDefaultTimerParams('three_months');
      v.getList();
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 取消手工订单
    cancelOrderBtn(obj) {
      let v = this;
      let ymsPackageGoods = obj.ymsPackageGoods || [];
      let newData = v.handleMultilinguaTableFields(ymsPackageGoods, ['title']);
      let ymsProductGoodsIds = [];
      if (newData.length > 0) {
        newData.map((item) => {
          ymsProductGoodsIds.push(item.ymsProductGoodsId)
        });
        if (ymsProductGoodsIds.length > 0) {
          (async () => {
            let newList = await v.getProductInfoByIds(ymsProductGoodsIds, newData);
            if (newList.length > 0) {
              newList.map((item) => {
                if (item._productInfo) {
                  let skuImgPath = item._productInfo.primaryImage;
                  let spuImgPath = item._productInfo._spuInfo.primaryImage;
                  let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
                  item.specifications = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                  item.name = item._productInfo._spuInfo.name;
                  item.ymsSku = item._productInfo.ymsSku;
                  item.pictureUrl = skuImgPath ? skuImgPath : spuImgPath;
                  item.cancelQuantity = 0;
                }
              })
            }
            v.$refs['cancelYmsOrder'].initCancelYmsOrderData(obj, newList);
          })();
        }
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 批量下单
    bulkOrderingBtn() {
      let query = {};
      let v = this;
      if (v.selectTableData.length <= 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004629'));
        return false;
      } else {
        query.packageCodes = v.selectTableData.map((item) => {
          return item.packageCode
        });
        v.$refs['distributorPayment'].initDistributorPaymentData('all', v.selectTableData);
      }
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPackageIds = v.selectTableData.map((item) => {
          return item.ymsPackageId
        });
      } else {
        query.ymsPackageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsDistributorPackageInfo_excelYmsPackageInfosExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },

    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      if (this.$refs.dropDownFilter) {
        this.$refs.dropDownFilter.inputValue = '';
      }
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 切换Tab
    changeTab() {
      let v = this;
      v.handleColumns();
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.pageParams.abnormalStatus = 'null';
        v.pageParams.orderShippingIds = '';
        v.resetDate();
        v.setDefaultTimerParams('three_months');
        v.selectTableData = [];
        v.pageParams.pageNum = 1;
        v.pageParamsStatus = true;
        v.$forceUpdate();
      });
    },
    // 获取待处理的商品数
    getProductsNum() {
      let v = this;
      v.reviewedTotal = 0;
      v.axios.get(api.get_ymsDistributorPackageInfo_queryTotal + '0').then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.reviewedTotal = data || 0;
          v.$store.commit('updatePendingCount', Date.now());
        }
      });
    },
    // 下发物流
    distributionLogisticsBtn(ymsPackageId) {
      let v = this;
      let ymsPackageIds = [ymsPackageId];
      v.axios.post(api.post_ymsPlatformOrder_syncUploadLogistics, ymsPackageIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.getProductsNum();
          v.pageParamsStatus = true;
        }
      });
    },
    // 取消订单成功
    cancelYmsOrderSuccess(data) {
      let v = this;
      v.getProductsNum();
      v.pageParamsStatus = true;
      if (data) {
        if (typeof data === 'string') {
          setTimeout(() => {
            const {href} = v.$router.resolve({
              path: '/myOrderDetails',
              query: {
                ymsPackageId: data
              }
            });
            window.open(href, '_blank');
          }, 1000);
        }
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (['null', '6'].includes(v.pageParams.orderTabStatus)) {
        v.tableColumns = v.originalColumns;
      } else {
        hideKeyList = ['sourceRemark'];
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyList.includes(item.key)
        })
      }
    },
    // 倒计时
    handleCountDown(ymsPackageId) {
      const v = this;
      if (!v.countdowns[ymsPackageId]) {
        v.$set(v.countdowns, ymsPackageId, {timer: null, leftTime: ''});
      }
      // 如果已有倒计时，清除
      if (v.countdowns[ymsPackageId].timer) {
        clearInterval(v.countdowns[ymsPackageId].timer);
      }
      let time = v.$uDate.dealTime(v.countdownsTime[ymsPackageId].payLeftTime, 'fulltime');
      const endTime = new Date(time).getTime();
      v.countdowns[ymsPackageId].timer = setInterval(() => {
        const now = Date.now();
        const remainingSeconds = Math.max(0, Math.floor((endTime - now) / 1000));
        const formattedTime = v.$uDate.formatTime(remainingSeconds);
        let value = remainingSeconds > 0 ? formattedTime : 0;
        v.$set(v.countdowns[ymsPackageId], 'leftTime', value);
        if (remainingSeconds <= 0) {
          clearInterval(v.countdowns[ymsPackageId].timer);
        }
      }, 1000);
    },
    // 下单成功，更新操作
    updateOrderData(obj) {
      let {text} = obj;
      this.$Message.success(text);
      this.pageParamsStatus = true;
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    orderSubmissionModal,
    cancelCustomizedProductOrdersModal,
    viewCustomizedInfoModal,
    cancelYmsOrderModal,
    trackingInfoModal,
    exportFieldsModal,
    dropDownFilter,
    orderTrajectoryModal,
    batchImportOrdersModal,
    distributorPaymentModal
  }
};
</script>
<style lang="less" scoped>
.table-box /deep/ .ivu-table .ivu-table-tbody {
  .ymsPackageGoodBox {
    width: 70px;
    height: 70px;
    position: relative;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    margin: 2px 5px;
    cursor: pointer;

    .ymsPackageGoodImg {
      width: 100%;
      height: auto;
      object-fit: cover;
      vertical-align: middle;
    }

    .ymsPackageGoodQuantity {
      padding: 2px 3px;
      border-radius: 4px;
      background-color: #fff;
      color: #000;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    .maskBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
  }

  .TiktokCBT_box {
    display: inline-block;
    padding: 0px 8px;
    border-radius: 15px;
    color: #FD5425;
    border: 1px solid #FD5425;
    margin-right: 5px;
    font-size: 12px;
  }
}
</style>